<template lang="pug">
.ticket-wrapper
  .upright.showInMobile {{ $t('common.item') }} &nbsp; {{itemIndex + 1}}
  section.ticket
    .ticket__left
      //- template(v-if="")
      //- if image is failed or no image show box 100x100 with icon
      // picture.ticket__image
        //- img(:src="ticket.performance.image['170x240']")
        ticket-icon-big(:type="'item'")
        // 100x140
      .upright.showInDesktop {{ $t('common.item') }} &nbsp; {{itemIndex + 1}}
      .ticket__left-wrapper
        // .ticket__qr
        // 100x100
        qr-code-vue(:value="item.qr || item.code" :size="100" level="H")

    .ticket__right
      // .ticket__tag {{$t('relatedProducts')}}
      .row(v-if="item.itemType && item.itemType == 'abonement'" style="flex-wrap:wrap;")
        .ticket__info.tag(@click="getInfo(item.id)")
          span(v-if="!info_loading") {{$t('info')}}
          .info-loader(v-if="info_loading")
        .ticket__prolong.tag(@click="prolong(item.itemId, item.institution ? item.institution.id : 0)")
          span {{$t('aside.abonements')}}
      .ticket__info-result
        span {{ info }}
        span {{ info_end }}
      .ticket__title {{ item.name }}
      .ticket__table
        .ticket__table-line {{$t('code')}}: <span>{{ item.code }}</span>
      .ticket__price {{$t('common.total')}}: {{ item.price | price }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}
      .ticket__footer
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QrCodeVue from 'qrcode.vue';
import TicketIconBig from '../icon/big-icon';

export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      default: () => (null),
      required: false,
    },
    orderId: {
      type: Number,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: false,
    },
  },
  data: () => ({
    more: [],
    info: '',
    info_end: '',
    info_loading: false,
    isIos: false,
    frameUrl: {
      'cabinet.guru.ge': 'saleframe.guru.ge',
      'cabinet.24afisha.by': 'saleframe.24afisha.by',
      'cabinet.minskarena.by': 'saleframe.minskarena.by',
      'my.bycard.by': 'saleframe.bycard.by',
      'cabinet.24afisha.arcom.of.by': 'saleframe.arcom.of.by',
    },
  }),
  computed: {
    ...mapGetters({
      getLayout: 'getLayout',
    }),
  },
  mounted() {
    if (/Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      this.isIos = true;
    }
    this.makeMore();
  },
  methods: {
    ...mapActions({
      openWidget: 'open',
      openService: 'openService',
      openServiceItem: 'openServiceItem',
    }),
    makeMore() {
    },

    doAction() {

    },

    update() {
      this.$emit('update');
    },

    getInfo(id) {
      this.info_loading = true;
      this.$axios.get(`/api/v3/users/me/orders/item/${id}`)
        .then((r) => {
          if (r && r.data && r.data.countVisits !== undefined && r.data.numberVisits !== undefined) {
            this.info = `${this.$t('countVisitsUsed')} ${r.data.countVisits} ${this.$t('in')} ${r.data.numberVisits}`;

            if (r.data.end && r.data.end < (new Date().getTime() / 1000)) {
              this.info_end = `${this.$t('abonEnd')}`;
            }
          }
        })
        .finally(() => {
          this.info_loading = false;
        });
    },
    prolong(itemId, institutionId) {
      if (this.isIos) {
        window.open('https://' + `${this.frameUrl[window.location.hostname]}/item?oid=${institutionId}&iid=${itemId}`, '_blank'); // eslint-disable-line
      } else {
        this.openServiceItem({ id: institutionId, openId: itemId, type: 'item' });
      }
    },
  },
  components: {
    QrCodeVue,
    TicketIconBig,
  },
};
</script>
<style lang="scss">
.line-through {
  display: flex;
  flex-direction: row;
}
.line-through span{
  text-decoration: line-through;
}
.line-through p{
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: brown;
}

.ticket:first-child {
  border-top: 0;
}

.upright {
  @media screen and (min-width: 960px){
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform:rotate(-90deg);
  }

  @media screen and (max-width: 960px){
    margin-top: 22px;
    margin-bottom: 10px;
  }

  margin-top: 40px;
  white-space: nowrap;
  font-size: 20px;
  font-weight: 600;
}

.qr-margin {
  @media screen and (max-width: 960px){
    margin-bottom: 10px;
  }
}

.return-ticket {
  @media screen and (min-width: 960px){
    color: #FF0000;
    border: 1px solid red;
    margin-top: 10px;
  }
  @media screen and (max-width: 960px){
    background: #fff;
  }
}

.ticket-wrapper {
  background: #efefef;
  border-top: 2px dashed lightgray;
  @media screen and (max-width: 960px){
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.ticket {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  // background: #efefef;

  @media screen and (max-width: 960px) {
    align-self: baseline;
  }

  padding: 0;

  // border-top: 2px dashed lightgray;

  &.returned {
    .ticket__title, .ticket__table-line, .ticket__price {
      color: #dad7d7;
    }
    .def-item-icon__train {
      background-color: #0099ff69;
    }
    .ticket__tag {
      background-color: #0099ff69;
      &-canceled {
        margin-left: .5rem;
        background-color: #ee4747;
      }
    }
    .er-status{
      border: 1px solid #0099ff69;
      color: #0099ff69;
       &.no-er {
      border: 1px solid #dba3a3;
      border-radius: 4px;
      color: #dba3a3;
    }
    }
  }

  &__left {
    // min-width: 100px;
    // max-width: 100px;
    // width: 100px;
    margin: 40px 0 40px 5px;
    display: flex;
    // flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    @media screen and (max-width: 960px) {
      flex-direction: column;
      margin: 3px 0 40px 10px;
      // padding: 10px;
    }
  }
  &__left-wrapper {
    min-width: 100px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
  }
  &__image {
    width: 100px;
    // height: 140px;
    margin-bottom: 20px;
    > img {
      border-radius: 4px;
      width: 100%;
    }
  }
  &__qr {
    min-width: 100px;
    max-width: 100px;
    width: 100px;
    max-height: 100px;
    min-height: 100px;
    height: 100px;
    border-radius: 4px;
    border: solid 1px rgb(229, 229, 229);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    @media screen and (max-width:960px) {
      margin-bottom: 0;
      min-width: 140px;
      max-width: 140px;
      width: 140px;
      max-height: 140px;
      min-height: 140px;
      height: 140px;
      // > div > canvas {
      // width: 120px !important;
      // height: 120px !important;
      // }
    }
  }

  .er-status {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100px;
    border: 1px solid rgb(0, 153, 255);
    border-radius: 4px;
    text-align: center;
    color: rgb(0, 153, 255);
    font-size: 11px;
    &.no-er {
      border: 1px solid #ee4747;
      border-radius: 4px;
      color: #ee4747;
    }
    .mark {
      width: 80px;
    }
  }

  &__right {
    width: 100%;
    margin: 40px 45px 40px 30px;
  }
  &__table {
    &-line {
      padding: 0 0 3px 0;
      font-family: Inter;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      // white-space: nowrap;
      line-height: normal;
      letter-spacing: normal;
      color: rgb(0, 0, 0);
      // border-top: 1px dashed rgb(229, 229, 229);
      > span {
        font-weight: 500;
      }
    }
    // border-bottom: 1px dashed rgb(229, 229, 229);
  }
  &__tag {
    display: inline-block;
    height: 30px;
    margin-bottom: 30px;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgb(255, 255, 255);
    border-radius: 3px;
    background-color: rgb(0, 153, 255);
    padding: 10px;
  }
  &__title {
    font-family: Inter;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: rgb(0, 0, 0);
    margin-bottom: 24px;
    @media screen and (max-width:960px) {
      font-size: 16px;
      word-break: break-word;
    }
  }
  &__info {
    margin-right: 10px;
    margin-bottom: 16px;
    width: 120px;
    border: 1px solid rgb(0, 153, 255);
    color: rgb(0, 153, 255);
    background: #fff;
    cursor: pointer;
    padding: 20px 14px;
    @media screen and (max-width: 960px) {
      margin-top: 2px;
    }
    span {
      text-align: center;
    }
  }
  &__prolong {
    margin-bottom: 16px;
    width: 120px;
    color: #000;
    background: #ffea00;
    border: 1px solid #ffea00;
    cursor: pointer;
    padding: 20px 14px;
    @media screen and (max-width: 960px) {
      margin-top: 2px;
    }
    span {
      text-align: center;
      line-height: normal;
    }
  }
  &__info-result {
    // margin-left: 10px;
    margin-bottom: 16px;
    display: flex;
    align-items: baseline;
    flex-direction: column;
    gap: .3rem;
  }
  &__price {
    // margin-top: 29px;
    // margin-bottom: 36px;
    margin-top: 18px;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgb(0, 0, 0);
  }
  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > * {
      margin: 0 5px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.table-line_wrapper {
  position: relative;
  margin-right:3rem;
}

// .table-line_wrapper:after{
//   content: " ";
//   background: #d3d3d3;
//   width: 2px;
//   height: 2rem;
//   /* линия смещена на 10px справа от текста*/
//   right: -1.5rem;
//   bottom: .8rem;
//   /* включаем абсолютное позиционирование относительно блока с relative */
//   position: absolute;
// }
.returnHover {
  margin-top: 1rem;
  @media screen and (max-width:960px) {
    margin-top: 0rem;
  }
}
.returnHover:hover {
  background-color: #fff;
  border: 1px solid #FF0000;
}
.wrapper_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-loader {
  width: 16.67px;
  aspect-ratio: 1;
  display: grid;
  -webkit-mask: conic-gradient(from 15deg, #0000, #000);
  animation: l26 1s infinite steps(12);
}
.info-loader,
.info-loader:before,
.info-loader:after {
  background:
    radial-gradient(closest-side at 50% 12.5%, rgb(0, 153, 255) 96%, #0000) 50% 0/20% 80% repeat-y,
    radial-gradient(closest-side at 12.5% 50%, rgb(0, 153, 255) 96%, #0000) 0 50%/80% 20% repeat-x;
}
.info-loader:before,
.info-loader:after {
  content: "";
  grid-area: 1/1;
  transform: rotate(30deg);
}
.info-loader:after {
  transform: rotate(60deg);
}

@keyframes l26 {
  100% { transform: rotate(1turn); }
}
</style>
